import { gsap } from 'gsap/all'
import { store } from '../../../src/js/core/store.js'

export class ArrowLink {
  constructor (element) {
    this.element = element
    this.icon = this.element.querySelector('.js-icon')
    this.timelinePlaying = false
    this.offset = 6

    if (!store.isDevice) {
      this.init()
    }
  }

  init = () => {
    this.createTimeline()
    this.bindEvents()
  }

  createTimeline = () => {
    this.timeline = new gsap.timeline({
      paused: true,
      onStart: () => {
        this.timelinePlaying = true
      },
      onComplete: () => {
        this.timelinePlaying = false
      }
    })

    this.timeline
      .to(this.icon, 0.25, { x: this.offset, opacity: 0, ease: 'power2.inOut' })
      .set(this.icon, { x: this.offset * -1 })
      .to(this.icon, 0.25, { x: 0, opacity: 1, ease: 'power2.out' })
  }

  bindEvents = () => {
    this.element.addEventListener('mouseenter', this.handleEnter)
  }

  handleEnter = () => {
    if (!this.timelinePlaying) {
      this.timeline.restart()
    }
  }
}
